import { FreeMarketLeadForm } from '@components/pages/mercado-livre-de-energia/section-form-banner/free-market-lead-form'
import { TextBase } from '@components/v2/text-base'
import { Title } from '@components/v2/title'
import styles from './styles.module.scss'

export const SectionFormBanner = () => {
  return (
    <div className={styles.wrapperContainer}>
      <div className="flex flex-col lg:px-3">
        <div className="w-full max-w-7xl self-center">
          <div className={styles.container}>
            <div className={styles.wrapperInfos}>
              <Title className={styles.title} level="h1">
                Entre no
                <span className="text-orange">
                  <strong> Mercado Livre </strong>
                </span>
                de Energia com o
                <span className="text-orange">
                  <strong> Portal Solar </strong>
                </span>
              </Title>
              <TextBase className={styles.description}>
                Garanta segurança e economia para a sua operação com as soluções
                do<strong> Portal Solar </strong>para o
                <strong> Mercado Livre de Energia Elétrica (ACL).</strong>
              </TextBase>
            </div>
            <div className={styles.wrapperForm}>
              <p className={styles.formTitle}>
                Economize com o
                <span className="text-orange font-semibold uppercase">
                  {' '}
                  Portal Solar
                </span>
              </p>
              <FreeMarketLeadForm />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
